import { Global } from '@emotion/core';
import { DatetimeGlobalStyles } from 'components/FieldDatetime/styles';
import { css } from 'emotion';
import React, { useState } from 'react';
import Datetime from 'react-datetime';
import { Control, useController } from 'react-hook-form';
import { Caret } from 'shared/Caret';
import { getCurrentDateAtUpcomingHour } from '../FieldDatetime/util';
import {
  ButtonSectionContainer,
  CalendarLabel,
  Container,
  Dropdown,
  DropdownWrapper,
  LocalTimezoneMessage,
  ModalContentContainer,
  PseudoLabel,
  PublishDateDisplay,
  StyledButton,
  StyledModal,
} from './styles';
import { getDisplayValue, roundToNextHour } from './utils';

const FieldDatePicker = ({
  label,
  name = 'publishOn',
  className,
  control,
  defaultValue,
}: {
  label: string;
  name?: string;
  className?: any;
  control?: Control;
  defaultValue?: string | null;
}) => {
  const [isShowingSchedulerModal, setIsShowingSchedulerModal] = useState(false);
  const {
    field: { value, onChange },
  } = useController({ control, name, defaultValue });

  const dateTimeValue =
    !value || value === '' ? getCurrentDateAtUpcomingHour() : value;

  const handleReset = () => {
    onChange(null);
    setIsShowingSchedulerModal(false);
  };
  return (
    <Container className={className}>
      <PseudoLabel aria-label={name}>{label}</PseudoLabel>
      <DropdownWrapper>
        <button
          onClick={() => setIsShowingSchedulerModal(true)}
          type="button"
          aria-label="Open date selector"
        >
          <Dropdown>
            <PublishDateDisplay>
              {getDisplayValue(value, null, 'Now')}
            </PublishDateDisplay>
            <Caret color="#5f6369" />
          </Dropdown>
        </button>
      </DropdownWrapper>
      <StyledModal
        isShowing={isShowingSchedulerModal}
        onClickClose={handleReset}
        isShowingCloseButton
        renderContent={() => (
          <ModalContentContainer>
            <CalendarLabel htmlFor={name}>
              {getDisplayValue(value, 'Schedule for', 'Publish now')}
              <Global styles={DatetimeGlobalStyles} />
              <Datetime
                className="DatetimeContainer"
                input={false}
                timeConstraints={{
                  minutes: { min: 0, max: 0, step: 60 },
                  seconds: { min: 0, max: 0, step: 60 },
                  milliseconds: { min: 0, max: 0, step: 1000 },
                }}
                onChange={date => {
                  onChange(roundToNextHour(date));
                }}
                value={dateTimeValue}
              />
            </CalendarLabel>
            <LocalTimezoneMessage>All times are local</LocalTimezoneMessage>
            <ButtonSectionContainer>
              <StyledButton
                kind="button"
                onClick={handleReset}
                className={css`
                  color: #5000b9;
                `}
              >
                Reset to now
              </StyledButton>
              <StyledButton
                kind="button"
                color="purple"
                onClick={() => setIsShowingSchedulerModal(false)}
              >
                Confirm
              </StyledButton>
            </ButtonSectionContainer>
          </ModalContentContainer>
        )}
      />
    </Container>
  );
};

export { FieldDatePicker };
